
<div style="padding-bottom: 20px;">
	<span>NDC Number: <span style="font-weight: bold;">{{ndcNumber}}</span>
	</span>
</div>
<div class="imgverify-container"
	style="display: flex; flex-direction: row; gap: 12px;">
	<!-- Left Section -->
	<div style="width: 40%;">
		<div class="table-container" (keydown)="tableKeyDown($event)"
			tabindex="-1">
			<table mat-table [dataSource]="medicationImages"
				(mouseleave)="doMouseOutImage()" style="width: 100%;">
				<!-- Match -->
				<ng-container matColumnDef="validated">
				<th mat-header-cell *matHeaderCellDef class="mat-table-header-style"
					style="text-align: left">Match</th>
				<td mat-cell *matCellDef="let element"><mat-checkbox
						[(ngModel)]="element.select" (change)="onCheckboxChange()"></mat-checkbox></td>
				</ng-container>

				<!-- Type -->
				<ng-container matColumnDef="imageType">
				<th mat-header-cell *matHeaderCellDef class="mat-table-header-style">Type</th>
				<td mat-cell *matCellDef="let medImage">{{medImage.imageType}}
				</td>
				</ng-container>

				<!-- Image -->
				<ng-container matColumnDef="imageUrl">
				<th mat-header-cell *matHeaderCellDef class="mat-table-header-style">Image</th>
				<td mat-cell *matCellDef="let medLink"><img
					[src]="BASE_URL + 'medications/medication-images/file/' + medLink.id"
					class="image-thumb"
					(mouseover)="doMouseOverImage($event)"></td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"
					(click)="onRowClicked(row)"></tr>
			</table>

			<div *ngIf="noImageFlag"
				style="font-size: 16pt; color: grey; text-align: center; padding-top: 50px;">
				No image(s) found</div>


		</div>
		<!-- Dosage Verification Section -->
		<div style="margin-top: 16px; ">
			<fieldset style="border: 1px solid #ccc; padding: 8px; padding-right: 0px;">
				<legend style="font-weight: bold;">Dosage Verification</legend>

				<div>
					Sampled By: <input type="text" readonly
						[value]="getFullUserName(sampledBy)"
						style="margin-left: 8px; border: none; border-bottom: 1px solid black; width: 150px; background: transparent;" />
				</div>

				<div style="margin-top: 8px;">
					Date: <input type="text" readonly [value]="sampledDate"
						style="margin-left: 47px; border: none; border-bottom: 1px solid black; width: 150px; background: transparent;" />
				</div>

				<button style="margin-top: 8px;float: right; scale: 90%"
                        matTooltip="Verify that the dose matches the image"
                        mat-button class="command-button" [disabled]="isVerifyDisabled()"
					(click)="verifyDosage()">
                    <mat-icon>check_circle_outline</mat-icon>
                    Verify
                </button>
			</fieldset>
		</div>

	</div>

	<!-- Right Section -->
	<div style="width: 60%;">
		<mat-tab-group style="height:100%">
			<mat-tab label="Medication">
			  <div>
			  	<button mat-button class="command-button" style="float: right;margin-top: 10px;width: 100px;" 
			  		(click)="openQuickaddEditMedicationDlg()"
					matTooltip="Edit medication details" mat-button>
					<mat-icon>edit</mat-icon>
					Edit
				</button>
			  </div>
			  <div class="medication-details mat-tab-detail-style" *ngIf="selectedMedication">
			   <table class="medication-table">
			    <tr class="medication-row">
			     <td class="medication-label">NDC Number:</td>
			     <td class="medication-value">{{ ndcNumber }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Medication Name:</td>
			     <td class="medication-value">{{ selectedMedication?.description }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Manufactured for:</td>
			     <td class="medication-value">{{ setSelectedManufacturerName(selectedMedication?.manufacturedForId,'for') }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Manufactured by:</td>
			     <td class="medication-value">{{ setSelectedManufacturerName(selectedMedication?.manufacturedById,'by') }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Package Size:</td>
			     <td class="medication-value">{{ selectedMedication?.packageSize }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Units:</td>
			     <td class="medication-value">{{ selectedFamily?.units }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Cost:</td>
			     <td class="medication-value">{{ selectedMedication?.lastCost }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">AWP:</td>
			     <td class="medication-value">{{ selectedMedication?.awp }}</td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Cost Per Unit:</td>
			     <td class="medication-value">
			      {{ calculateCostPerUnit(selectedMedication?.lastCost, selectedMedication?.packageSize) }}
			     </td>
			    </tr>
			    <tr class="medication-row">
			     <td class="medication-label">Cost Base:</td>
			     <td class="medication-value">{{ selectedFamily?.costBase }}</td>
			    </tr>
			   </table>
			  </div>
			 </mat-tab>

			<mat-tab label="Ingredients">
			<div class="mat-tab-detail-style">
			  <div  style="font-weight: bold; margin-bottom: 14px;margin-top: 10px;margin-left: 8px;">Ingredients:</div>
			  <div style="padding: 8px;" *ngIf="ingredients?.length">
			    <table mat-table [dataSource]="ingredients" class="mat-elevation-z1" style="width: 100%;">
			      <ng-container matColumnDef="ingredient">
			        <th mat-header-cell *matHeaderCellDef> Ingredient </th>
			        <td mat-cell *matCellDef="let element"> {{ element.ingredient }} </td>
			      </ng-container>
			
			      <ng-container matColumnDef="quantity">
			        <th mat-header-cell *matHeaderCellDef> Quantity </th>
			        <td mat-cell *matCellDef="let element"> {{ element.quantity +' '+element.uom }} </td>
			      </ng-container>
			
			      <ng-container matColumnDef="code">
			        <th mat-header-cell *matHeaderCellDef> Code </th>
			        <td mat-cell *matCellDef="let element"> {{ element.abcxyiCode }} </td>
			      </ng-container>
			
			      <tr mat-header-row *matHeaderRowDef="['ingredient', 'quantity', 'code']"></tr>
			      <tr mat-row *matRowDef="let row; columns: ['ingredient', 'quantity', 'code']"></tr>
			    </table>
			  </div>
			  <div *ngIf="!ingredients?.length" style="padding: 8px; color: gray;">
			    No ingredients available.
			  </div>
            </div>
			</mat-tab>
			
			<mat-tab label="Storage">
				  <div class="mat-tab-detail-style" style="padding: 8px;">
				    <div style="font-weight: bold; margin-bottom: 20px;">Storage:</div>
				      <textarea matInput style="width: 540px;margin-left: 7px;resize: none;" [readonly]="true" [value]="selectedMedication?.storageInstructions" rows="8"></textarea>
				    
				  </div>
				</mat-tab>

		</mat-tab-group>
	</div>
</div>

<!-- Approve / Cancel Buttons -->
<div
	style="margin-top: 16px; text-align: center; position: absolute; bottom: 25px; width: 100%">
	<button mat-button class="command-button"
		[disabled]="!hasCheckedItems()" (click)="doSubmitImgVerify()"
		matTooltip="Submit the selected record" mat-button>
		<mat-icon>check_circle_outline</mat-icon>
		Approve
	</button>
	<button mat-button class="command-button" (click)="doCancelImgVerify()"
		matTooltip="Cancel submission" mat-button>
		<mat-icon>highlight_off</mat-icon>
		Cancel
	</button>
</div>

<p-dialog header="Show Image"
          [showHeader]="false"
          [(visible)]="dispLargeImage"
          [modal]="false"
          [style]="{position: 'absolute', right: '450px'}"
          appendTo="body"
          [resizable]="false" [closable]="false">
    <img src="{{largeImgUrl}}"  alt="something"  >
</p-dialog>

<p-dialog header="Quick Edit Medication"
          [(visible)]="displayQuickMedicationAddEditDlg"
          [modal]="true"
          [style]="{width: '730px', height: '800px'}"
          appendTo="body"
          [closable]="true"
          [resizable]="false"
          [focusOnShow]="false">

  <app-quickaddmedication (cancelClicked)="displayQuickMedicationAddEditDlg=false"
        (submitClicked)="setMedicationRecord($event)" #quickAddMed></app-quickaddmedication>

</p-dialog>
